import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import HomePage from './Pages/HomePage';
import MyListPage from './Pages/MyListPage';
import SearchResultsPage from './Pages/SearchResultsPage';
import MoviePage from './Pages/MoviePage';
import ErrorPage from './Pages/ErrorPage';
import PrivateRoute from './components/PrivateRoute';
import AuthWrapper from './components/AuthWrapper';
const App = () => {
  return (
    <AuthWrapper>
      <Router>
        <Switch>
          <Route exact path='/'>
            <HomePage />
          </Route>
          <PrivateRoute exact path='/my-list'>
            <MyListPage />
          </PrivateRoute>
          <Route exact path='/movie/:id'>
            <MoviePage />
          </Route>
          <Route>
            <Route exact path='/search-results/:query'>
              <SearchResultsPage />
            </Route>
          </Route>
          <Route path='*'>
            <ErrorPage />
          </Route>
        </Switch>
      </Router>
    </AuthWrapper>
  );
};

export default App;
